import IconClose from '@tvg/fuse-icons/lib/Close';
import { EUserAction } from 'client/config';
import { usePLPNavigate } from 'client/hooks/usePLPNavigate';
import { SEOAnchorStyled } from 'client/pages/CheckboxGroup/SEOAnchorStyled/SEOAnchorStyled';
import { useDrawerState } from 'client/state/Drawer';
import { FacetType } from 'common/types/facet';
import React, { useCallback } from 'react';
import { ChipButtonStyled } from './ChipList.styled';

interface ChipProps {
  id: string;
  name: string;
  facetId: string;
  href: string;
  onMouseEnter?: React.MouseEventHandler<HTMLAnchorElement>;
  onFocus?: React.FocusEventHandler<HTMLAnchorElement>;
}

function Chip({ id, name, facetId, href, onFocus, onMouseEnter }: ChipProps) {
  const plpNavigate = usePLPNavigate();
  const toggleShowViewProducts = useDrawerState((s) => s.toggleShowViewProducts);

  const handleRemove = useCallback(
    (e: React.FormEvent<HTMLElement>) => {
      e.preventDefault();
      toggleShowViewProducts.on();
      plpNavigate({ facet: { id: facetId, option: id } }, EUserAction.FACET);
    },
    [facetId, id, plpNavigate, toggleShowViewProducts],
  );

  return (
    <li>
      <SEOAnchorStyled href={href} className="forSEO" tabIndex={-1} onMouseEnter={onMouseEnter} onFocus={onFocus}>
        <ChipButtonStyled
          icon={<IconClose />}
          iconRight
          onClick={handleRemove}
          data-value={`${id}_${name}`}
          data-testid="chip-button"
          aria-label={`${name} filter selected, click to remove`}
        >
          {facetId === FacetType.rating ? `Customer rating ${name}` : name}
        </ChipButtonStyled>
      </SEOAnchorStyled>
    </li>
  );
}

export default React.memo(Chip);
